module.exports = __webpack_public_path__ + "img/indexfirst.943861d3.jpg";